export const environment: {
  production: boolean,
  name: string,
  hmr: boolean,
  URL_ME?: string,
  useBearerToken?: boolean
} = {
  production: false,
  name: 'main',
  hmr: false,
  useBearerToken: true,
};

const BASE_URL = 'https://apidev.conexaopovosdafloresta.org.br';


export const API_BASE_URL = `https://apidev.conexaopovosdafloresta.org.br/api`;
export const SANCTUM_URL = `${BASE_URL}/sanctum/csrf-cookie`;

export const GEOSERVER_URL = `${BASE_URL}/api/geoserver`;
export const GEE_IMAGE_API_BASE_URL = `${BASE_URL}/gee-api`;

export const PLANET_API_KEY = 'PLAK09a503e58b5140d7aeb34c26959d7430';

export const URL_GEO_API = `${BASE_URL}/api/geoserver`;
